import { render, staticRenderFns } from "./lognotenurseitemrightbar.vue?vue&type=template&id=3497bf24&"
import script from "./lognotenurseitemrightbar.vue?vue&type=script&lang=js&"
export * from "./lognotenurseitemrightbar.vue?vue&type=script&lang=js&"
import style0 from "./lognotenurseitemrightbar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports